(function () {
  function initCartUpsells() {
    const upsellSections = document.querySelectorAll('.cart-item__upsell');

    upsellSections.forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';

      // 1. Accordion Toggle
      const toggle = section.querySelector('.cart-item__upsell-toggle');
      toggle.addEventListener('click', () => {
        section.classList.toggle('is-open');
        // Trigger Flickity resize when opening
        if (section.classList.contains('is-open')) {
          initActiveSlider(section);
        }
      });

      // 2. Tab Switching
      const tabs = section.querySelectorAll('.cart-item__upsell-tab');
      const contents = section.querySelectorAll('.cart-item__upsell-tab-content');

      const switchTab = (targetTab, shouldFocus = false) => {
        let activeTab = null;

        tabs.forEach((t) => {
          const isActive = t.dataset.tab === targetTab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          t.setAttribute('tabindex', isActive ? '0' : '-1');

          if (isActive) {
            activeTab = t;
          }
        });

        contents.forEach((content) => {
          const isActive = content.dataset.tabContent === targetTab;
          content.classList.toggle('is-active', isActive);
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          if (isActive) {
            initActiveSlider(section);
          }
        });

        if (shouldFocus && activeTab) {
          activeTab.focus();
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          switchTab(tab.dataset.tab);
        });

        tab.addEventListener('keydown', (event) => {
          const tabsArray = Array.from(tabs);
          const currentIndex = tabsArray.indexOf(tab);
          if (currentIndex === -1) return;

          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % tabsArray.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabsArray.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          const nextTab = tabsArray[nextIndex];
          if (!nextTab) return;

          switchTab(nextTab.dataset.tab, true);
        });
      });

      // 3. Increment/Decrement
      section.addEventListener('click', (e) => {
        const minusBtn = e.target.closest('.qty-minus');
        const plusBtn = e.target.closest('.qty-plus');

        if (minusBtn || plusBtn) {
          const input = e.target.closest('.upsell-card__quantity').querySelector('.qty-input');
          const parsedValue = Number.parseInt(input.value, 10);
          let val = Number.isNaN(parsedValue) ? 1 : parsedValue;

          if (minusBtn) {
            val = Math.max(1, val - 1);
          } else {
            val++;
          }

          input.value = val;
        }
      });

      // 4. AJAX Add to Cart
      section.addEventListener('click', (e) => {
        const button = e.target.closest('.js-upsell-add');
        if (button) {
          const variantId = button.dataset.variantId;
          const quantity = button.closest('.upsell-card__info').querySelector('.qty-input').value;
          const labelDefault = button.dataset.labelDefault || button.textContent;
          const labelAdding = button.dataset.labelAdding || labelDefault;
          const labelAdded = button.dataset.labelAdded || labelDefault;
          const labelError = button.dataset.labelError || labelDefault;

          button.disabled = true;
          button.textContent = labelAdding;

          const formData = {
            items: [
              {
                id: variantId,
                quantity: Number.parseInt(quantity, 10),
              },
            ],
          };

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {
              button.textContent = labelAdded;
              document.dispatchEvent(new CustomEvent('cart:build'));
              fetch(window.Shopify.routes.root + 'cart.js')
                .then((r) => r.json())
                .then((cart) => {
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
                });
              setTimeout(() => {
                button.disabled = false;
                button.textContent = labelDefault;
              }, 2000);
            })
            .catch((error) => {
              console.error('Error:', error);
              button.disabled = false;
              button.textContent = labelError;
              setTimeout(() => {
                button.textContent = labelDefault;
              }, 2000);
            });
        }
      });
    });
  }

  function initActiveSlider(section) {
    const activeContent = section.querySelector('.cart-item__upsell-tab-content.is-active');
    if (!activeContent) return;

    const sliderContainer = activeContent.querySelector('.cart-item__upsell-slider');
    if (!sliderContainer) return;

    if (sliderContainer.classList.contains('flickity-enabled')) {
      sliderContainer.flickityInstance.resize();
      return;
    }

    // Only init if more than 1 slide (or if user wants slider even for 1)
    const slides = sliderContainer.querySelectorAll('.cart-item__upsell-slide');
    if (slides.length > 0) {
      const flkty = new Flickity(sliderContainer, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: true,
        groupCells: false, // Individual cards
      });
      sliderContainer.flickityInstance = flkty;
      sliderContainer.classList.remove('flickity-viewport-off');
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', initCartUpsells);

  // Re-init on AJAX cart load/update (common Shopify theme events)
  document.addEventListener('cart:updated', initCartUpsells);
  document.addEventListener('cart:refresh', initCartUpsells);

  // For themes that use MutationObserver for the drawer
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    const observer = new MutationObserver((mutations) => {
      // Small delay to ensure DOM is ready
      setTimeout(initCartUpsells, 100);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
